import { useEffect, useState, useMemo } from 'react'
import {
  InfluencerData,
  InfluencerDetails,
  InfluencerTableFilters,
} from '../../../core/interface/chronique.interface'
import InfluencerTableViewContainer from '../influencerTable/InfluencerTableViewContainer'
import RecapChroniqueur from '../shared/RecapChroniqueur'
import { TableViewTypeInfluencerEnum } from '../../../core/enums/table-view-type-influencer.enum'
import { Input } from '../../ui/input'

const Influencer = ({ data }: { data: InfluencerDetails[] }) => {
  const [influencersData, setInfluencersData] = useState<InfluencerData[]>([])
  const [userSelected, setUserSelected] = useState<InfluencerData | null>(null)
  const [selectedUsers, setSelectedUsers] = useState<InfluencerData[]>([])
  const [showFilters, setShowFilters] = useState(false)
  const [headerFilters, setHeaderFilters] = useState<InfluencerTableFilters>({
    status: [],
  })
  const [inputValue, setInputValue] = useState('')

  const convertToInfluencerData = (
    details: InfluencerDetails[],
  ): InfluencerData[] => {
    return details.map((influencer) => ({
      influencer,
      current_influencedbook_status: null,
      affinity: 0,
      form_completed: false,
      note: null,
      already_influenced_for_publisher: false,
      promises: [],
    }))
  }

  useEffect(() => {
    setInfluencersData(convertToInfluencerData(data))
  }, [data])

  // Filtrage des données par email
  const filteredInfluencersData = useMemo(() => {
    if (!inputValue.trim()) {
      return influencersData
    }

    return influencersData.filter((influencerData) =>
      influencerData.influencer.email
        ?.toLowerCase()
        .includes(inputValue.toLowerCase().trim()),
    )
  }, [influencersData, inputValue])

  const handleResetFiltersAndSelections = () => {
    setSelectedUsers([])
    setShowFilters(false)
    setInputValue('') // Reset de la recherche par email
    setHeaderFilters({
      selection: [],
      status: [],
      alreadyInfluenced: [],
      chronique: [],
      complete: [],
      promise: [],
    })
  }

  return (
    <div className="flex-auto flex flex-col px-8 py-4 gap-4 w-full">
      <div
        className="flex-auto flex flex-col bg-white rounded-xl px-8 pt-8 pb-4 h-[80vh] relative gap-4"
        style={{
          boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
        }}
      >
        <RecapChroniqueur
          viewType={TableViewTypeInfluencerEnum.INFLUENCERS_VIEW}
          selectedUsersCount={selectedUsers.length}
          bookSelected="Influencers"
          setShowFilters={setShowFilters}
          showFilters={showFilters}
          handleResetFiltersAndSelections={handleResetFiltersAndSelections}
        />
        <Input
          type="text"
          placeholder="Rechercher un chroniqueur vis son adresse mail"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="w-1/3"
        />
        <div className="h-full flex flex-col overflow-hidden">
          {filteredInfluencersData.length > 0 && (
            <InfluencerTableViewContainer
              viewType={TableViewTypeInfluencerEnum.INFLUENCERS_VIEW}
              data={filteredInfluencersData}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              userSelected={userSelected}
              setUserSelected={setUserSelected}
              showFilters={showFilters}
              headerFilters={headerFilters}
              setHeaderFilters={setHeaderFilters}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Influencer
